import { Observable } from 'rxjs';
import { ValueHelperModel } from '../models/low-level/value-helper.model';
import { InjectionToken } from '@angular/core';

export interface OdataValueHelperInterface {
    getValueHelpers(): Observable<ValueHelperModel[]>;
}

export const OdataValueHelperInstanceToken = new InjectionToken<OdataValueHelperInterface>('OdataValueHelperInterface');
